import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';
import { IPhasePerformanceContracts } from 'components/Dashboards/Portfolio/phasePerformance/phasePerformance.types';

const queryFn = (params: QueryParams) => {
    const url = 'api/bo/phaseperformance/getTemplateRelatedProjects';
    return network.post(url, { template_id: params.templateId }).then((response) => {
        return response.data;
    });
};

export const useQueryPhasePerformanceGetTemplateRelatedProjects = (params: QueryParams) => {
    return useQuery<QueryFnResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getTemplateRelatedProjects', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.templateId),
    });
};

interface QueryParams {
    templateId?: string | number | null;
}

export type QueryFnResponse = IPhasePerformanceContracts;

type QueryResponse = QueryFnResponse & {};
